import styled from "styled-components/macro";
import { PRICING_MOBILE_BREAKPOINT } from "../constants";

export const StyledFAQ = styled.div`
  button {
    font-size: 16px;
    background: #4808d1;
    color: #fff;
    border: 0;
    border-radius: 20px;
    font-family: Inter;
    font-weight: 500;
    padding: 10px 40px;
    cursor: pointer;
    margin-top: 15px;
  }
  font-family: "GT Super Text";
  background: #2a2315;
  text-align: left;
  color: white;
  margin: auto;
  min-height: 500px;
  box-sizing: border-box;
  padding-bottom: 120px;
  padding-top: 80px;

  .faq-section-container {
    margin: auto;
    max-width: 500px;
    font-family: 'GT Super Text';
    font-weight: 300;
  }

  section {
    > span {

      &:nth-of-type(1) {
        font-size: 24px;
      }

      &:nth-of-type(2) {
        font-size: 24px;
        max-width: 500px;
        display: block;
        margin-bottom: 40px;

        a {
          text-decoration: underline;
        }
      }

      &.faq-sub-headline {
        text-align: left;
        margin-left: 0px;
        margin-top: 20px;
        font-size: 20px;

        a {
          color: #888;
        }
      }

      &.faq-pre-headline {
        text-align: left;
        margin-left: 0px;
        margin-bottom: 0px;
        letter-spacing: 0.17em;
        font-family: "Inter";
        font-size: 16px;
        font-weight: 500;
      }
    }

    &.faq-section {
      text-align: left;
    }
  }

  h1 {
    font-family: "GT Super Text";
    margin: auto;
    text-align: center;
    padding: 20px;

    &.faq-headline {
      text-align:left;
      font-size: 36px;
      padding-right: 0;
      margin-left: 0;
      padding-left:0;
      padding-top: 15px;
      padding-bottom: 0;
      color: #F5F2E4;
      font-weight: 500;
    }
  }

  p {
    padding: 15px;
    margin: auto;
    max-width: 600px;
    line-height: 1.6em;
    &.didnt-see {
      color: #f5f2e4;
      padding-left: 0;
    }
  }

  ul {
    list-style-type: none;

    li {
      p:nth-of-type(1) {
        font-weight: bold;
        padding-bottom: 0;
      }
      p:nth-of-type(2) {
        padding-top: 0;
      }

      a {
        color: #f5f2e4;
        text-decoration: underline;
      }
    }

    &.faq-question-list {
      color: #f5f2e4;

      li {
        p {
          padding-left: 0;
          padding-bottom: 5px;
        }
      }
    }
  }

  .button-container {
    padding-top: 0px;
    width: 500px;
    margin: auto;
    position: relative;
    button.faq-ask-button {
      float: right;
      border-radius: 5px !important;
      padding-left: 15px !important;
      padding-right: 15px !important;
      background:  #9B51E0;
    }
    input {
      background: none !important;
      border: 2px solid #f5f2e4 !important;
      font-size: 16px !important;
      font-family: "Inter" !important;
      font-weight: 100 !important;
      border-radius: 20px !important;
      color: white;
      margin: auto;
      display: block;
      width: 100%;
      box-sizing: border-box;
      height: 65px;
      padding: 10px;
      padding-top: 0;
      padding-left: 15px;
    }
  }

  @media screen and (max-width: ${PRICING_MOBILE_BREAKPOINT}) {
    padding-bottom: 80px !important;
    section {
      > span {
        &.faq-sub-headline {
          opacity: 0.8;
          line-height: 28px;
          font-weight: 500;
          .only-an-email {
            padding-bottom: 0px;
            text-decoration-thickness: 1.5px;
            text-underline-offset: 3px;
          }
        }
        &.faq-pre-headline {
          opacity: 0.8;
        }
      }
    }

    h1 {
      text-align: left !important;
      &.faq-headline {
        padding-top: 5px;
      }
    }

    > span {
      &:nth-of-type(1) {
        font-size: 15px;
        letter-spacing: 1px;
        padding-top: 30px;
        text-align: left !important;
      }

      &:nth-of-type(2) {
        font-size: 20px;
        line-height: 1.4em;
        text-align: left !important;
        display: block;
        margin: auto;
        margin-bottom: 40px;
      }
    }

    p {
      font-size: 22px;
    }
    ul {
      &.faq-question-list {
        li {
          p {
            .faq-answer-link {
              padding-bottom: 0px;
              text-decoration-thickness: 1.5px;
              text-underline-offset: 3px;
            }
          }
        }
      }
    }

    }
    .button-container {
      width: auto;
    }
  }
`;
